import React, {Component} from "react"
import { Table, Row, Input, message, Select, Icon, Button } from "antd"
import { observable } from "mobx"
import { observer, inject } from "mobx-react"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import closeIcon from "app/styles/images/sp/close.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import cx from "classnames"
import { disposeFileSize } from "app/vendor/util"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import FlexableFileName from "app/components/normal/FlexableFileName"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import getPathogen from "app/utils/pathogenDispose"
import { debounce } from "../../../../vendor/util"

const Option = Select.Option

const ObserverPrimerSelector = observer(({record, index, totalPrimers, onSelect, onDeselect}) => {
  const filterOption = (inputValue, option) => option.key.search(new RegExp(inputValue, "i")) > -1

  return (
    <div className="ta-c">
      <Select
        multiple
        style={{ width: "90%" }}
        placeholder="请输入并选择引物后运行"
        value={record.primers.slice()}
        filterOption={filterOption}
        onSelect={onSelect}
        onDeselect={onDeselect}>
        {totalPrimers.slice().map(primer => <Option key={primer}>{primer}</Option>)}
      </Select>
    </div>
  )
})

const ObserverRelationSelector = observer(({record, relations, onChange}) => {
  return (
    <div className="ta-c relation-helper-wrapper">
      {record.marked && <span className="relation-helper" style={{background: record.color}}/>}
      <Select
        style={{ width: "75%" }}
        placeholder="请选择关系"
        value={record.relationName}
        onChange={onChange}>
        {relations.slice().map(relation => <Option key={relation.id}>{relation.name}</Option>)}
      </Select>
    </div>
  )
})

const ObserverPathogenSelector = observer(({record, onChange}) => {
  const pathogenList = getPathogen(record.relationName)
  let keys = []
  let values = []

  if (pathogenList) {
    keys = [...pathogenList.keys()]
    values = [...pathogenList.values()]
  }

  return (
    <div className="ta-c relation-helper-wrapper">
      <Select
        style={{ width: "90%" }}
        placeholder="请选择致病性"
        value={record.pathogen || undefined}
        onChange={onChange}
      >
        {keys.map(
          (key, index) => <Option key={key}>{values[index]}</Option>)
        }
      </Select>
    </div>
  )
})

const ObserverInput = observer(({record, field, onChange, placeholder}) => {
  return (
    <div className="ta-c">
      <Input
        style={{ width: "95%" }}
        value={record[field]}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  )
})

const ObserverSampleName = observer(({record, editHistoryList, onChange, onVisibleChange}) => {
  const sampleNameEllipsis = (
    <MaterialTip
      overlayClassName="ellipsis-tip"
      title={record.sampleName}>
      <div className="sample-name ellipsis cursor-p">{record.sampleName}</div>
    </MaterialTip>
  )

  return (
    record.hasHistory
      ? (
          <Row className="cursor-p" type="flex" justify="center" align="middle">
            <WarningTip
              type="warningTip"
              text={sampleNameEllipsis}
              justify="start"
              mainKeys={["versionNum", "sampleName", "createTime"]}
              overlayClassName="ta-c"
              historyData={editHistoryList}
              onVisibleChange={onVisibleChange}
            />
          </Row>
        )
      : record.hasName
        ? (
          <div className="ta-c">
            {sampleNameEllipsis}
          </div>
        )
        : (
          <ObserverInput
            record={record}
            field="sampleName"
            onChange={onChange}
            placeholder="请手动填写样本名"
          />
        )
  )
})
const Observerremark = observer(({record, onChange}) => {
  return (
    record.hasRemark
    ? (
      <MaterialTip
        title={record.remark}
      >
        <div className="ellipsis ta-c">
          {record.remark}
        </div>
      </MaterialTip>
    )
    : (
      <ObserverInput
        record={record}
        field="remark"
        placeholder="请手动填写备注"
        onChange={onChange}
      />
    )
  )
})

const ObserverOperator = observer(({record, onClick}) => {
  //let editIcon, editTitle

  // [editIcon, editTitle] = record.hasName || record.hasRemark  // 如果需要判断禁用，解除掉注释并修改src为editIcon、title为editTitle
  //   ? [editAbleIcon, "修改"]
  //   : [editDisableIcon, "请先填写并保存样本名"]
  return (
    <Row className="table-oprator" type="flex" justify="center" align="middle">
      <img
        className={cx({disable: !record.hasName && !record.hasRemark, "cursor-p": true})}
        title="修改"
        src={editAbleIcon}
        alt=""
        onClick={onClick}
      />
    </Row>
  )
})

@inject("pgdDataManageDetail")@observer
export default class extends Component {
  state={
    showDeleteModal: false,
    showEditModal: false,
    focusedSample: {},
    editedHistory: [],
  }

  componentDidMount() {
    const { pgdDataManageDetail } = this.props
    pgdDataManageDetail.initTableData()
    .then(() => {
      pgdDataManageDetail.loadPrimers()
      pgdDataManageDetail.loadRelations()
    }, err => {
      message.error(err.message)
    })
  }

  showOperateModal = ({record, type}) => {
    // if (!record.hasName) {    // 现在不需要判断是否禁用了，如果需要解除掉注释即可
    //   return
    // }

    if (type === "delete") {
      this.showDeleteModal(record)
    } else {
      this.showEditModal(record)
    }
  }

  showDeleteModal = (record) => {
    this.setState({
      showDeleteModal: true,
      focusedSample: record,
    })
  }

  showEditModal = (record) => {
    this.currentSampleName = record.sampleName

    this.setState({
      showEditModal: true,
      focusedSample: record
    })
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  onSelectChange = (selectedRowKeys) => {
    this.props.pgdDataManageDetail.selectedRowKeys = selectedRowKeys
  }

  toggleHistory = (visible, record) => {
    const { loadEditHistory, clearEditHistory } = this.props.pgdDataManageDetail
    if (visible) {
      loadEditHistory(record.dataId)
    } else {
      clearEditHistory()
    }
  }

  @debounce()
  parseCSV = () => {
    const { parseCSV } = this.props.pgdDataManageDetail
    parseCSV(this.csvInput.refs.input.value)
      .then(() => {
        message.success('解析成功')
        this.csvInput.refs.input.value = ''
      })
      .catch(err => {
        message.error(err.message)
        return Promise.reject(err)
      })
  }

  deleteSample = (sampleId) => {
    const { pgdDataManageDetail: { deleteSample, deleteData } } = this.props
    deleteSample(sampleId)
    .then(
      res => {
        this.setState({
          showDeleteModal: false
        })
        deleteData(sampleId)
        message.success("数据删除成功")
      },
      err => {
        message.error(err.message)
      }
    )
  }

  render() {
    const { focusedSample, showEditModal } = this.state
    const {
        tableData,
        selectedRowKeys,
        totalPrimers,
        familyInfo,
        onPrimerSelect,
        onPrimerDeselect,
        onRelationChange,
        onSampleNameChange,
        editHistoryList,
        relations,
        onPathogenChange
    } = this.props.pgdDataManageDetail

    this.columns = [
      {
        title: <div className="ta-l">文件名称</div>,
        dataIndex: "filename",
        width:"17.34%",
        render: (filename, record, index) => {
          return (
            <FlexableFileName filename={filename} matched={record.matched}/>
          )
        }
      }, {
        title: <div className="ta-c">样本名/条码</div>,
        dataIndex: "sampleName",
        width:"18.32%",
        render: (sampleName, sample, index) => {
          return (
            <ObserverSampleName
              record={sample}
              editHistoryList={editHistoryList}
              onChange={(e) => onSampleNameChange(e.target.value, sample)}
              onVisibleChange={(visible) => this.toggleHistory(visible, sample)}
            />
          )
        }
      }, {
        title: (<div className="ta-c">样本备注</div>),
        dataInde: "remark",
        width: 75,
        render: (text, record) => {
          const { onInputChange } = this.props.pgdDataManageDetail
          return (
            <Observerremark
              record={record}
              onChange={(e) => onInputChange(e.target.value, record, "remark")}
              placeholder="请手动填写备注"
            />
          )
        }
      }, {
        title: <div className="ta-c">关系</div>,
        width: 190,
        dataIndex: "relationName",
        render: (relationName, sample, index) => (
          <ObserverRelationSelector
            record={sample}
            relations={relations}
            onChange={(relationId) => onRelationChange(relationId, sample)}
          />
        )
      }, {
        title: <div className="ta-c">致病性</div>,
        width: 180,
        dataIndex: "pathogen",
        render: (relationName, sample, index) => (
          <ObserverPathogenSelector
            record={sample}
            onChange={(key) => onPathogenChange(key, sample)}
          />
        )
      }, {
        title: <div className="ta-c">引物</div>,
        width: 210,
        dataIndex: "primers",
        render: (primers, sample, index) => (
          <ObserverPrimerSelector
            record={sample}
            index={index}
            totalPrimers={totalPrimers}
            onDeselect={(primer) => onPrimerDeselect(primer, sample)}
            onSelect={(primer) => onPrimerSelect(primer, sample)}
          />
        )
      }, {
        title: <div className="ta-r">数据大小</div>,
        dataIndex: "size",
        width: 90,
        render: (byteCount, record) =>
          <div className="ta-r">{disposeFileSize(byteCount)}</div>
     }, {
        title: <div className="ta-c">上传日期</div>,
        dataIndex: "uploadTime",
        width: 90,
        render: (text) =>
          <div style={{ whiteSpace: 'pre-line' }} className="ta-c">{text.replace(' ', '\n')}</div>
     }, {
        title: <div className="ta-c">操作</div>,
        dataIndex: "operator",
        width: 80,
        render: (text, record) => (
          <ObserverOperator
            record={record}
            onClick={() => this.showOperateModal({record, type: "edit"})}
          />
        )
      }
    ]

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    }

    return(
      <div>
        <div className="wrapper-box">
          <Row type="flex" justify='start' align='middle' className='subtitle'>
            <i></i>
            <div>数据列表</div>
            <div className="promotion">注：在关系中显示同一颜色角色表示数据为同一人</div>

            {/* <Input
              type='textarea'
              ref={input => this.csvInput = input}
              style={{ width: 140, height: 28, resize: 'none'}}
              placeholder='请粘贴 csv 文本内容'
            />
            <Button
              type="primary"
              size="default"
              style={{marginLeft: 10}}
              onClick={this.parseCSV}>
              解析
            </Button> */}
          </Row>
          <Table
            className="datamanage-detail-table"
            rowSelection={rowSelection}
            columns={this.columns}
            rowKey={record => record.id}
            dataSource={tableData.slice()}
            pagination={false}
          />
          <MaterialModal
            title="数据删除确认"
            className="upload-delete-modal"
            buttonType="danger"
            buttonText="删除"
            visible={this.state.showDeleteModal}
            action={() => this.deleteSample(focusedSample.id)}>
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={()=>this.closeModal("showDeleteModal")}
            />
            <div className="sub-title">家系：{familyInfo.name}</div>
            <div className="description">{focusedSample.filename}</div>
            <div className="warning">
              <Icon type="exclamation-circle-o" />
              您确定要删除家系中的本条数据吗？
            </div>
          </MaterialModal>
          <EditModal
            visible={showEditModal}
            sample={focusedSample}
            onClose={() => this.closeModal("showEditModal")}
            // onConfirm={newName => {
            //   focusedSample.sampleName = newName
            //   focusedSample.hasHistory = true
            // }}
          />
        </div>
      </div>
    )
  }
}

@inject("pgdDataManageDetail")@observer
class EditModal extends Component {
  @observable currentSampleName = ""
  @observable currentremark = ""

  componentWillReceiveProps (props) {
    this.currentSampleName = props.sample.sampleName
    this.currentremark = props.sample.remark
  }

  onSampleNameChange = e => {
    this.currentSampleName = e.target.value
  }

  onremarkChange = e => {
    this.currentremark = e.target.value
  }

  updateSample = () => {
    const { onClose, sample, pgdDataManageDetail: { updateSample } } = this.props

    if (!(this.currentSampleName || " ").trim()) {
      message.warning("样本名不能为空")
      return
    }

    updateSample(this.currentSampleName, this.currentremark, sample.dataId)
    .then(res => {
      sample.sampleName = this.currentSampleName // 因为 sample 是对 mobx 对象的一个引用
      sample.remark = this.currentremark // 因为 sample 是对 mobx 对象的一个引用
      sample.hasHistory = true // 因为 sample 是对 mobx 对象的一个引用
      sample.hasRemark = true // 因为 sample 是对 mobx 对象的一个引用

      onClose()
      message.success("编辑保存成功")
    }, err => {
      message.error(err.message)
    })
  }

  render () {
    const { sample, visible, onClose } = this.props

    return (
      <MaterialModal
        title="数据编辑"
        buttonText="保存"
        className="pgd-datamanage-detail-modal"
        visible={visible}
        action={this.updateSample}
        buttonType="primary">
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <MaterialForm justify="center" >
          <MaterialFormItem
            justify="center"
            labelText="文件名称">
            <FlexableFileName className="edit-filename" filename={sample.filename} matched={true} />
          </MaterialFormItem>
          <MaterialFormItem
            justify="center"
            labelText="样本名">
            <Input className="edit-samplename"
              value={this.currentSampleName}
              onChange={this.onSampleNameChange}/>
          </MaterialFormItem>
          <MaterialFormItem
            justify="center"
            labelText="样本备注">
            <Input className="edit-samplename"
              value={this.currentremark}
              onChange={this.onremarkChange}/>
          </MaterialFormItem>
        </MaterialForm>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgd/data_manage_detail/containers/DataTable.js